"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Flex_1 = __importDefault(require("../Flex"));
var Text_1 = __importDefault(require("../Text"));
var DropdownFooter = styled_components_1.default(Flex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: wrap;\n  ", ";\n  ", " {\n    text-align: center;\n    color: ", ";\n  }\n"], ["\n  flex-wrap: wrap;\n  ", ";\n  ", " {\n    text-align: center;\n    color: ", ";\n  }\n"])), style_utils_1.setPadding("x", 2), Text_1.default, style_utils_1.getColor("gray", 300));
DropdownFooter.defaultProps = {
    alignItems: "center",
    justifyContent: "center"
};
exports.default = DropdownFooter;
var templateObject_1;
//# sourceMappingURL=index.js.map